import './infoTrack.scss'
import clx from 'classnames'
import Marquee from "react-fast-marquee";
import { useState } from 'react';

export interface IPropsInfoTrack {
    album: string,
    artist: string | undefined,
    isSelected?: boolean,
    isToAudio?: boolean,
    className?: string,
}

export const InfoTrack = ({ album, artist, isSelected, isToAudio, className }: IPropsInfoTrack) => {
    const classInfoAlbum = clx('a-infoTrack__album', {
        '--selected': isSelected,
        '--toAudio': isToAudio,
        '--ellipsis': !isToAudio
    })

    const [direction, setDirection] = useState(false);
    const [isMarquee, setIsMarquee] = useState<('left' | 'right' | undefined)>()

    const loopMarquee = () => {
        setDirection(!direction)
        setIsMarquee(direction ? 'left' : 'right')
    }

    return (
        <article className={`a-infoTrack ${className}`}>
            {
                isToAudio && album?.length > 30 ?
                    <Marquee className='a-infoTrack__marquee' gradient={false} speed={10} direction={isMarquee} loop={10}
                        onCycleComplete={() => loopMarquee()}
                    >
                        <span className={classInfoAlbum}>{album}</span>
                    </Marquee>
                    :
                    <span className={classInfoAlbum}>{album}</span>
            }
            <span className='a-infoTrack__artist'>{artist}</span>
        </article>
    )
}
